import { useState } from 'react';

import ErrorComponent from '@/components/common/error-component/ErrorComponent';
import { WidgetComponent } from '@/forms/components/widget';
import useEffectOnlyOnUpdate from '@/hooks/useEffectOnlyOnUpdate/useEffectOnlyOnUpdate';

import classes from './Textarea.module.scss';

const Textarea = ({
	label,
	name,
	placeholder,
	value,
	readOnly,
	disabled,
	onChange,
	required,
	form,
	widgetArgs,
	resDataAfterSubmit,
}: WidgetComponent) => {
	const elId = `id_${name}`;

	const [errorAfterSubmit, setErrorAfterSubmit] = useState<string[] | null>(
		null
	);

	useEffectOnlyOnUpdate(() => {
		if (resDataAfterSubmit) {
			const { errorMessage } = resDataAfterSubmit;
			if (Object.entries(errorMessage).length > 0) {
				// eslint-disable-next-line unicorn/no-lonely-if
				if (errorMessage[name]) setErrorAfterSubmit(errorMessage[name]);
			}
		}
	}, [resDataAfterSubmit]);

	const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		setErrorAfterSubmit(null);
		onChange(e.target.value);
	};

	return (
		<section
			className={[classes.container, classes[name]].join(' ')}
			data-error={errorAfterSubmit ? true : undefined}
		>
			{label && <label htmlFor={elId}>{label}</label>}
			<textarea
				form={form}
				className={classes.textarea}
				placeholder={placeholder}
				name={name}
				id={elId}
				defaultValue={!(value instanceof Date) && value ? value : ''}
				onChange={handleChange}
				disabled={disabled}
				readOnly={readOnly}
				required={required}
				{...(widgetArgs || {})}
			></textarea>
			{errorAfterSubmit?.map((i, idx) => {
				return (
					<ErrorComponent key={idx} clazz={classes.error}>
						{`*${i}`}
					</ErrorComponent>
				);
			})}
		</section>
	);
};

export default Textarea;
